const table = resource => `[data-resource="${resource}"][data-relation="main"] table`
const action = (resource, name) => `[data-resource="${resource}"][data-relation="main"] [data-action-name="${name}"]`
const definitions = {
  statuses: [
    { key: 'statuses', selector: table('statuses'), list: true, required: true },
    { key: 'status_create', selector: action('statuses', 'create'), create: true }
  ],
  fees: [
    { key: 'fees', selector: table('fees'), list: true, required: true }
  ],
  teams: [
    { key: 'teams', selector: table('teams'), list: true, required: true }
  ],
  people: [
    { key: 'people', selector: table('people'), list: true, required: true },
    { key: 'joining', selector: action('people', 'joining_assistant'), required: true },
    { key: 'finish', selector: action('people', 'create'), actionsMenu: true, required: true, article: true }
  ]
}

export { definitions as firstPersonOrientationDefinitions }

// The server supplies the available stages and action permissions. The browser
// plans only presentation; it never chooses a route or a skipped destination.
export function firstPersonOrientationStages(stages) {
  const plan = {}
  for (const stage of stages || []) {
    if (!definitions[stage.key]) return null
    const steps = definitions[stage.key].filter(step => !step.create || stage.create).map(step => ({ ...step }))
    if (stage.key !== 'people') steps.at(-1).navigate = 'next'
    plan[stage.key] = steps
  }
  return plan
}
